/**
 * 基础组件导出文件
 */
import OnAutocomplete from './autocomplete/index.vue';
import OnButton from './button/index.vue';
import OnCollapsiblePanel from './collapsible-panel/index.vue';
import OnCollapsiblePanelItem from './collapsible-panel/item.vue';
import OnInput from './input/index.vue';
import OnSelect from './select/index.vue';
import OnTextarea from './textarea/index.vue';

// 所有基础组件列表
const components = [
  OnButton,
  OnCollapsiblePanel,
  OnCollapsiblePanelItem,
  OnInput,
  OnSelect,
  OnAutocomplete,
  OnTextarea,
];

// 定义 install 方法
const install = function(Vue) {
  // 遍历注册全局组件
  components.forEach(component => {
    Vue.component(component.name, component);
  });
};

// 判断是否直接引入文件
if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue);
}

export {
  install,
  OnButton,
  OnCollapsiblePanel,
  OnCollapsiblePanelItem,
  OnInput,
  OnSelect,
  OnAutocomplete,
  OnTextarea,
};

export default {
  install,
};
